import { all } from 'redux-saga/effects';
import { authSaga } from './authSaga';
import { customizationSaga } from './customizationSaga';
import { collectionsSaga } from './collectionsSaga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    customizationSaga(),
    collectionsSaga(),
  ]);
}
